/* hamropatro firebase config for production */

import {useNepali} from "./languageText";
import {englishToNepali} from "./Common";

let config = {
    apiKey: 'AIzaSyDz9DzH59ZfYKqwMJpE1Id0LtCyVkAvYY8',
    authDomain: 'hamropatro.firebaseapp.com',
    databaseURL: 'https://hamropatro.firebaseio.com',
    projectId: 'hamropatro',
    storageBucket: '',
    messagingSenderId: '366682898353'
};


/* hamropatro-android firebase config for development */

// let config = {
//     apiKey: 'AIzaSyAx1rN_KoTMfqI8O5dU1INfhmUtnRH6XcU',
//     authDomain: 'hamropatro-android-test.firebaseapp.com',
//     databaseURL: 'https://hamropatro-android-test.firebaseio.com',
//     projectId: 'hamropatro-android-test',
//     storageBucket: 'hamropatro-android-test.appspot`.com',
//     messagingSenderId: '27021292206'
// };

const globalConfig = {

    /* Production config */

    BackendUrl: {'url': 'https://everestbackend-api.hamropatro.com'},
    appSecreteGoogle: {'key': 'AIzaSyCmuuoSSykIiwZAA0XlNLdknZwkNljgA8M'},
    appId: 'hamropatro', // production
    APIURL: 'https://taligali-api.hamropatro.com/',  // API calls For Production
    IMEBusinessID: '8c30bc80-8374-11e9-b839-0242ac120023', // production
    miniAppId: "bba31690-8f83-11ef-adb6-d6c61ae2b827",


    /* Development config */

    // BackendUrl: {'url': 'https://dev-dot-everestbackend-api-dev.dallas-hamrostack.com'},
    // appSecreteGoogle: {'key': 'v1DSRxAMFyjWYKSH7Itj'}, // hamropatro-android-test
    // appId: 'hamropatro-android', // development
    // APIURL: 'https://api-dev-dot-taligali.dallas-hamrostack.com/',
    // IMEBusinessID: '30c05e40-8370-11e9-9b6c-0242ac14007d', // dev


    web_apiKey: 'ce15f30b-fb9b-4baf-b0f1-6ab88b3baa2f',
    firebaseApps: {},
    firebaseConfig: config
};

export function isLogin() {
    if (localStorage.getItem(globalConfig.appId + '_quiz_role') !== null) {
        return true;
    }
}

export function getUserID() {
    if (localStorage.getItem(globalConfig.appId + '_uID') !== null) {
        return localStorage.getItem(globalConfig.appId + '_uID');
    }
}
export function getUserInfo() {
    if (localStorage.getItem(globalConfig.appId + '_user') !== null) {
        return JSON.parse(localStorage.getItem(globalConfig.appId + '_user'));
    }else return {"displayName": '',"photo_url": '',"user_id": ''}
}

export function translateError(axiosError) {
    let message = '';
    let status = '';
    let data = '';
    if (axiosError.response) {
        status = axiosError.response.status;
        message = axiosError.response.message;
        data = axiosError.response.data;
        return {msg: message, status: status, data: data};
    } else if (axiosError.request) {
        message = 'Network Error';
    } else {
        message = axiosError.message;
    }

    let sendData = {
        'msg': message
    };

    return {msg: message, status: status, data: sendData};
}

export function memberCountValue(member) {
    if (member) {
        if (member >= 1 && member < 1000) return useNepali  ? englishToNepali(member) : member;
        else if (member >= 1000 && member < 1000000) {
            let number = Math.round((member / 1000).toFixed(1) * 100) / 100;
            return useNepali  ? englishToNepali(number) + 'K' : number + 'K';
        } else if (member >= 1000000 && member < 10000000) {
            let mNumber = (member / 1000000).toFixed(2);
            return useNepali  ? englishToNepali(mNumber) + 'M' : mNumber + 'M';
        } else return useNepali  ? englishToNepali(member) : member;
    } else return useNepali  ? englishToNepali(member) : member;
}


export default globalConfig;